import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ReturnStoreCorporateDet } from '../model/ReturnStoreCorporateDet';

@Injectable()
export class ReturnStoreCorporateFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetDetailByReqCorporateId(returnReqCorporateId : Number): Observable<RequestResponse<ReturnStoreCorporateDet[]>> {
        return this._httpClient.get<RequestResponse<ReturnStoreCorporateDet[]>>(this._urlBase + 'api/ReturnStoreCorporate/DetByReturnReqCorporateId?returnReqCorporateId='+returnReqCorporateId);
    }
}
